import { ComponentType, createElement, SVGProps } from 'react';
import { Icon } from '@api/ringil-api.v2';
import SvgCheckSquare from '@icons/check-square.svg?react';
import SvgUnloaded from '@icons/unload.svg?react';
import SvgFlag from '@icons/flag.svg?react';
import SvgAlert from '@icons/alert.svg?react';
import SvgPlay from '@icons/play.svg?react';
import SvgResponsible from '@icons/responsible.svg?react';
import SvgPencil from '@icons/pencil-inverted.svg?react';
import SvgEntry from '@icons/entry.svg?react';
import SvgExit from '@icons/exit.svg?react';

const iconMapping: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
    'unloaded': SvgUnloaded,
    'check-square': SvgCheckSquare,
    'flag': SvgFlag,
    'alert': SvgAlert,
    'play': SvgPlay,
    'responsible': SvgResponsible,
    'pencil': SvgPencil,
    'entry': SvgEntry,
    'exit': SvgExit,
  };

  export const resolveStateIcon = (icon: Icon) => {
    if (!icon?.name) return null;

    const iconComponent = iconMapping[icon.name.toLowerCase()];
    if (!iconComponent) return null;

    return createElement(iconComponent, {
      className: `text-${icon.color} mr-1 shrink-0 fill-current`
    });
  };